import { t } from '@lingui/core/macro';

export const getShouldNotHappenError = (value: unknown, signature: string): Error => {
  return new Error(`should not happen: [${signature}] with value [${value}]`);
};

export const shouldNotHappen = (value: unknown, signature: string): never => {
  throw getShouldNotHappenError(value, signature);
};

export const booleanToString = (value: boolean) => {
  return value ? t`Oui` : t`Non`;
};
